import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

export default async function staffTicketTiersByEvent(event_pk) {
  const pk = event_pk?.pk != null ? event_pk.pk : event_pk;
  const { data } = await axios.get(routes.staffTicketTiersByEvent(pk), {
    ...AXIOS_DEFAULT_CONFIG,
  });
  return data;
}
